<section class="error-area">
    <div class="container">
        <div class="error-content">
            <img src="assets/img/404.png" alt="error">
            <h3>Page Not Found</h3>
            <p>The page you are looking for may have been removed due to our irresponsible nature.</p>
            <a routerLink="/" class="btn btn-secondary">Go Home</a>
        </div>
    </div>
</section>
